import React, { PureComponent } from 'react';
import cn from 'classnames';

import { i18n } from '@lt/localization';
import { Button } from '@lt/components';
import { truncString } from '../../../../../../utils/stringUtils';
import { formatDateToDayFull } from '../../../../../../utils/dateUtils';

import type { Props, State } from './types';
import styles from './testimonial.module.css';

class Testimonial extends PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
    };
  }

  showMoreInfo = () => this.setState({ showMore: true });

  render() {
    const {
      data: { client, content, id, created_at },
      isMobile = false,
    } = this.props;

    if (!content) return null;

    const { showMore } = this.state;
    const cutLength = isMobile ? 240 : 350;
    const extendedLength = content.length > cutLength;
    const showButton = !showMore && extendedLength;
    const titleClassName = cn(styles.text, styles.title, {
      [styles.mobileText]: isMobile,
    });

    return (
      <div key={id} className={styles.item}>
        {!isMobile && (
          <img className={styles.avatar} src={client.photo} alt={client.name} />
        )}
        <div className={styles.content}>
          {/* Header */}
          <div className={styles.header}>
            {isMobile && (
              <img
                className={cn(styles.avatar, styles.mobileAvatar)}
                src={client.photo}
                alt={client.name}
              />
            )}
            <div
              className={cn(styles.titleContainer, {
                [styles.mobileTitleContainer]: isMobile,
              })}
            >
              <p className={titleClassName}>{client.name}</p>
              {!isMobile && <p className={titleClassName}>·</p>}
              <p className={titleClassName}>{client.ordered}</p>
            </div>
          </div>

          {/* Testimonial */}
          <p
            className={cn(styles.text, styles.testimonial, {
              [styles.mobileText]: isMobile,
            })}
          >
            {showButton && extendedLength
              ? truncString(content, cutLength)
              : content}
          </p>

          {/* Addon */}
          <div className={styles.addon}>
            {showButton && (
              <Button
                functional
                className={cn(styles.text, styles.link, {
                  [styles.mobileText]: isMobile,
                })}
                onClick={this.showMoreInfo}
              >
                {i18n.t('checkout.testimonial.readMore')}
              </Button>
            )}
            <p className={cn(styles.text, { [styles.mobileText]: isMobile })}>
              {formatDateToDayFull(created_at)}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonial;
